import type { IconData } from '@stacksjs/iconify-core'

export const contentConfirmFile: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M0 0h8l4 4v2.5A5.5 5.5 0 0 0 6.875 14H0z\"/><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8.07 11.247A4.001 4.001 0 0 1 16 12a4 4 0 1 1-7.93-.753m6.43-.186L13.44 10l-1.88 1.879l-1-1l-1.06 1.06L11.56 14z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default contentConfirmFile
